import { Modal, ModalTitle, ModalBody } from 'design-system/src/components/Modal';
import { useState } from 'react';
import Button from 'design-system/src/components/Button/Button';
import ButtonRow from 'design-system/src/components/ButtonRow/ButtonRow';
import PharmacySearch from './PharmacySearch';

export default function PharmacySearchModal({
  onClose,
  onSubmit,
  rxId,
}: {
  onClose: () => void;
  onSubmit: () => void;
  rxId: string;
}) {
  const [hasSelection, setHasSelection] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitTrigger, setSubmitTrigger] = useState(0);

  const handlePharmacySubmit = () => {
    onSubmit();
    onClose();
  };

  const handleConfirm = () => {
    setSubmitTrigger((prev) => prev + 1);
  };

  return (
    <Modal onClose={onClose}>
      <ModalTitle>Select patient's preferred pharmacy</ModalTitle>
      <ModalBody>
        <PharmacySearch
          rxId={rxId}
          onSubmit={handlePharmacySubmit}
          onSelectionChange={setHasSelection}
          onSubmittingChange={setIsSubmitting}
          submitTrigger={submitTrigger}
          hideHeaders
        />
        <ButtonRow>
          <Button variant="tertiary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={!hasSelection} isLoading={isSubmitting}>
            Confirm pharmacy
          </Button>
        </ButtonRow>
      </ModalBody>
    </Modal>
  );
}
